<template>
  <form v-on:submit.prevent="addSoilTestsResults">
    <div class="modal-card">
      <header class="modal-card-head" style="background:#222">
        <p class="modal-card-title" style="color:white">
          <span style="color: #7cda24">Add Results</span> {{ result._id }}
        </p>
      </header>
      <section class="modal-card-body">
        <b-field label="PH Only">
          <b-input type="text" v-model="result.phOnly" placeholder="10 ">
          </b-input>
        </b-field>
        <b-field label="Nitrogen">
          <b-input type="text" v-model="result.nitrogen" placeholder="10 ">
          </b-input>
        </b-field>
        <b-field label="Potassium">
          <b-input type="text" v-model="result.potassium" placeholder="10 ">
          </b-input>
        </b-field>

        <b-field label="Magnesium">
          <b-input type="text" v-model="result.magnesium" placeholder="10 ">
          </b-input>
        </b-field>
        <b-field label="Organic Matter">
          <b-input type="text" v-model="result.OrganicMatter" placeholder="10 ">
          </b-input>
        </b-field>
        <b-field label="Salinity">
          <b-input type="text" v-model="result.salinity" placeholder="10 ">
          </b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary is-outlined" type="submit">
          Add Result
        </button>
        <button class="button is-dark" type="button" @click="$parent.close">
          Close
        </button>
      </footer>
    </div>
  </form>
</template>

<script>
import { ucFirst, currencies, ls } from "@/helpers";
import { mapGetters } from "vuex";
import decode from "jwt-decode";

export default {
  name: "addNewResultModal",
  data() {
    return {};
  },
  props: ["result"],
  computed: {
    userAuth() {
      return ls("token") ? decode(ls("token")) : null;
    },
    isAdmin() {
      return this.userAuth ? this.userAuth.subject === "admin" : false;
    },
    isProvincialManager() {
      return this.userAuth
        ? this.userAuth.type === "provincial-manager"
        : false;

    }
  },
  created() {},
  methods: {
    addSoilTestsResults() {
      const loading = this.$loading.open();
      this.$store
        .dispatch("addSoilTestsResults", this.result)
        .then(() => {
          loading.close();
          this.$parent.close();
          this.$toasted.global.success(
            `Soil Tests Results Updated Successfully!`
          );
          this.$emit("reload");
        })
        .catch(e => {
          loading.close();
          console.log("Exception when adding test results", e);
          this.$toasted.global.error(
            "Failed to add results. Please try again."
          );
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SoilTests/AddSoilTestResultModal.vue